<template>
    <div>
        <div class="home_img">
            <img src="../assets/img/admin.jpg" style="height: 120px;width: 1200px">
        </div>
        <!-- <p style="text-align: center;color: #407338;font-size: 30px"><b><i>Brassica</i> Database</b></p> -->
    </div>
</template>

<script>
    export default {
        name: "Header"
    }
</script>

<style>

</style>